import { createSlice } from '@reduxjs/toolkit';

import { ContestType } from '@/types/domain';

interface IContestState {
  contest: ContestType;
}

const initialState = {
  contest: {},
} as IContestState;

const pickemSlice = createSlice({
  name: 'contest',
  initialState,
  reducers: {
    SET_CURRENT_CONTEST(state, action) {
      state.contest = action.payload;
    },
  },
});

export default pickemSlice.reducer;
export const { SET_CURRENT_CONTEST } = pickemSlice.actions;
